<script>
import 'bulma/css/bulma.css'
import { updateNotification } from '@/api/FirebaseViewWrapper.js'
import { getUserData } from '@/api/FirebaseUserWrapper.js'
import { getNotificationMsg } from '@/api/NotificationUtilities.js'
import { formatDate } from '@/api/Utilities.js'
import Router from '@/router/index.js'

export default {
  components: {
  },
  props: ['data'],
  data () {
    return {
      creatingUserData: null,
      htmlContent: '',
      isCreated: false,
      contentFlag: false
    }
  },
  async created () {
    this.htmlContent = await getNotificationMsg(this.data)
    this.creatingUserData = await getUserData(this.data.creatingUserId)
    this.isCreated = true
  },
  methods: {
    async clickViewNotifiedProfile (data) {
      // goTreeが発火しないようにFlagを立てる
      this.contentFlag = true
      // 通知コンテンツがクリックされたのでコンテンツに飛んで通知を非表示にする
      this.$emit('clickViewNotified', false)
      // 既に見た通知ならここでreturn
      if (data.viewFlag) { return }
      // 初見の通知ならFrontの通知数カウントを１つ減らす
      this.$emit('decreaseNotifiedCount', true)
      // 初見の通知ならfirestoreのviewFlagをtrueにする
      data.viewFlag = true
      await updateNotification(data)
    },
    async goTree (data) {
      if (this.contentFlag) {
        this.contentFlag = false
        return
      }

      // 現状のpathとqueryが完全同一の場合、routerの同一パス指定はエラーになるのでreturnで抜ける
      if (location.pathname === `/tree/${this.data.targettedTreeId}` && location.search === `?node=${this.data.number}`) { return }

      // 通知コンテンツがクリックされたのでコンテンツに飛んで通知を非表示にする
      this.$emit('clickViewNotified', false)

      if (!data.viewFlag) {
        // 初見の通知ならFrontの通知数カウントを１つ減らす
        this.$emit('decreaseNotifiedCount', true)
        // 初見の通知ならfirestoreのviewFlagをtrueにする
        data.viewFlag = true
        await updateNotification(data)
      }
      Router.push({ path: `/tree/${this.data.targettedTreeId}`, query: { node: `${this.data.number}` } })
    }
  },
  filters: {
    timestampToDate: function (ts) {
      return formatDate(ts.toDate(), 'yyyy/MM/dd HH:mm')
    }
  }
}
</script>
<style scoped>
.notify {
  padding: 0.5rem;
  border-bottom: 1px solid #dbdbdb;
}
.notify:hover {
  background-color: #edfeff;
}
.unread {
  background-color: #d9f0f8;
}
.card-content {
  padding-top: 0rem;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  padding-bottom: 0rem;
}
.is-size-8 {
  font-size: 0.5rem !important;
}
.media-left {
  z-index: 29;
}
</style>
<template>
  <div class="notify" v-if="isCreated" v-bind:class="{'unread' : !data.viewFlag}" @click="goTree(data)">
    <div class="card-content">
      <div class="media is-marginless">
        <div class="media-left">
          <router-link v-bind:to="{ path: '/profile/' + data.creatingUserId }" @click.native="clickViewNotifiedProfile(data)">
            <figure class="image is-24x24">
              <img class="is-rounded" :src="creatingUserData.imageUrl">
            </figure>
          </router-link>
        </div>
        <div class="media-content has-text-left">
          <div v-html="htmlContent"></div>
          <div class="columns is-mobile is-marginless">
            <div class="column is-paddingless has-text-right">
              <time class="text is-size-8" datetime="2016-1-1">
                {{ data.createdAt | timestampToDate }}
              </time>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// src/components/globals/header/NotifiedCard.vue